import cn from 'classnames';
import React, { HTMLProps } from 'react';

export enum ContainerWidth {
  Standard = 'STANDARD',
  Narrow = 'NARROW',
  ExtraNarrow = 'EXTRA_NARROW',
}

export interface ContainerProps extends HTMLProps<HTMLDivElement> {
  containerWidth?: ContainerWidth;
  noPadding?: boolean;
}

export const Container: React.FC<ContainerProps> = ({
  children,
  className,
  containerWidth = ContainerWidth.Standard,
  noPadding = false,
  ...props
}) => (
  <div
    className={cn(
      'mx-auto h-full w-full',
      {
        'lg:w-[1048px]': containerWidth === ContainerWidth.Standard,
        'sm:w-full md:max-w-[564px]': containerWidth === ContainerWidth.Narrow,
        'max-w-[400px]': containerWidth === ContainerWidth.ExtraNarrow,
        'px-4 md:px-6 lg:px-4': !noPadding,
      },
      className
    )}
    {...props}>
    {children}
  </div>
);
